import Box from "@mui/material/Box";
import styled from "styled-components";

export const StyledDateMonthPicker = styled(Box)`
  display: flex;
  flex-direction: column;

  .label {
    font-size: 14px;
    margin-bottom: 4px;
    color: ${({ theme }) => theme.custom?.primary?.dark || '#1a4fd9'};
  }

  .ant-picker {
    height: 42px !important;
    border-radius: 12px;
    border: 2px solid ${({ theme }) => theme.palette?.info?.light || '#60a5fa'};
    box-shadow: none;
    background-color: ${({ theme }) => theme.palette?.info?.light || '#60a5fa'} !important;
    margin: 0 !important;

    .ant-picker-active-bar {
      background-color: ${({ theme }) => theme.custom?.primary?.main || '#2162FF'};
    }

    &:hover {
      border: 2px solid ${({ theme }) => theme.custom?.primary?.main || '#2162FF'};
    }
    input {
      font-size: 12px;
      color: ${({ theme }) => theme.custom?.primary?.dark || '#1a4fd9'} !important;
    }
  }

  .ant-picker-input {
    input {
      &::placeholder {
        color: ${({ theme }) => theme.custom?.secondary?.main || '#64748b'};
      }
    }
  }
`;
